<!-- 拼团-倒计时 -->
<template>
  <div
    :class="{
      'group-countdown-2': type === 2,
      'pc-group-countdown': !isH5,
      'mobile-group-countdown': isH5,
    }"
  >
    <div class="count-text">
      仅剩
      <p v-if="day">
        <span>&nbsp;{{ day }}&nbsp;</span>天
      </p>
    </div>
    <div class="count-time" v-html="content"></div>
  </div>
</template>
<script>
import { isH5 } from "@saas/components/src";
export default {
  data: function () {
    return {
      content: "", //<span>03</span>天<span>03</span>小时<span>03</span>分<span>03</span>秒
      timer: null,
      textShow: true,
      day: 0,
      isH5: isH5(),
    };
  },
  props: {
    endTime: {
      type: Number,
      default: 0,
    }, //结束时间-10位时间戳
    endText: {
      type: String,
      default: "已结束",
    },
    type: {
      type: Number,
      default: 1,
    }, //1:一行  2：两行
    item: {
      type: Object,
      default() {
        return {};
      },
    }, //？？？
    callback: {
      type: Function,
      default() {
        return function () {};
      },
    },
    intervalTime: {
      type: Number,
      default: 100,
    }, //倒计时间隔
    activityType: {
      type: Number,
      default: 4, //活动类型
    },
  },
  mounted() {
    this.startInterval(this.endTime, this.type);
  },
  methods: {
    countDown(timestamp, type = 1) {
      if (!timestamp || timestamp < 1) return;
      const nowTime = new Date();
      const endTime = new Date(timestamp * 1000);
      const t = endTime.getTime() - nowTime.getTime();
      if (t > 0) {
        const day = Math.floor(t / 86400000);
        let hour = Math.floor((t / 3600000) % 24);
        let min = Math.floor((t / 60000) % 60);
        let sec = Math.floor((t / 1000) % 60);
        // hour = hour < 10 ? "0" + hour : hour;
        min = min < 10 ? "0" + min : min;
        sec = sec < 10 ? "0" + sec : sec;
        let format = "";
        if (this.activityType === 4) {
          let ms = Math.floor(t % 1000);
          if (ms.toString().length < 4) {
            let num = 4 - ms.toString().length;
            ms = Array(num + 1).join("0") + ms.toString();
          }
          if (day > 2) {
            hour = hour < 10 ? "0" + hour : hour;
            this.day = day;
            format = `<span>${hour}</span><i>:</i><span>${min}</span><i>:</i><span>${sec}</span>`;
          } else {
            hour = day * 24 + hour;
            hour = hour < 10 ? "0" + hour : hour;
            format = `<span>${hour}</span><i>:</i><span>${min}</span><i>:</i><span>${sec}</span><i>:</i><span class="ms">${ms}</span>`;
          }
        } else {
          hour = hour < 10 ? "0" + hour : hour;
          if (day > 0) {
            this.day = day;
            format = `<span>${hour}</span><i>:</i><span>${min}</span><i>:</i><span>${sec}</span>`;
          }
          if (day <= 0 && hour > 0) {
            format = `<span>${hour}</span><i>:</i><span>${min}</span><i>:</i><span>${sec}</span>`;
          }
          if (day <= 0 && hour <= 0) {
            format = `<span>${min}</span><i>:</i><span>${sec}</span>`;
          }
        }

        this.content = format;
      } else {
        this.stopInterval();
      }
    },
    stopInterval() {
      this.textShow = false;
      clearInterval(this.timer);
      this.content = this.endText;
      this._callback();
    },
    startInterval(timestamp, type) {
      this.countDown(timestamp, type);
      this.timer = setInterval(() => {
        this.countDown(timestamp, type);
      }, this.intervalTime);
    },
    _callback() {
      if (this.callback && this.callback instanceof Function) {
        this.callback(this.item);
      }
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>
<style lang="scss">
.count-text {
  display: flex;
}
.pc-group-countdown {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 400;
  font-size: 11px;
  color: #747573;
  .count-text {
    line-height: 16px;
    margin-right: 6px;
  }
  .count-time {
    display: flex;
    align-items: center;
    span {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 16px;
      height: 16px;
      font-weight: 500;
      font-size: 10px;
      color: #ff4067;
      background: rgba($color: #ffccdb, $alpha: 0.7);
      border-radius: 4px;
    }
    .ms {
      width: 34px;
      height: 16px;
    }
    i {
      font-style: normal;
      color: #ff4067;
      font-weight: 500;
      font-size: 10px;
      padding: 0 6px;
    }
  }
}
.pc-group-countdown.group-countdown-2 {
  display: flex;
  flex-direction: column;
  align-items: center;
  .count-text {
    margin-right: 0;
    margin-bottom: 5px;
  }
}
.mobile-group-countdown {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 400;
  font-size: 0.29rem;
  color: #747573;
  .count-text {
    line-height: 0.44rem;
    margin-right: 0.17rem;
  }
  .count-time {
    display: flex;
    align-items: center;
    span {
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 500;
      font-size: 0.32rem;
      color: #ff4067;
      width: 0.48rem;
      height: 0.48rem;
      background: rgba($color: #ffccdb, $alpha: 0.7);
      border-radius: 0.11rem;
    }
    .ms {
      width: 1rem;
      height: 0.48rem;
    }
    i {
      font-style: normal;
      color: #ff4067;
      font-weight: 500;
      font-size: 0.32rem;
      padding: 0 0.11rem;
    }
  }
}
.mobile-group-countdown.group-countdown-2 {
  display: flex;
  flex-direction: column;
  align-items: center;
  .count-text {
    margin-right: 0;
    margin-bottom: 0.15rem;
  }
}
</style>
